"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceOption = void 0;
var SpaceOption = /** @class */ (function () {
    function SpaceOption() {
        this.id = 0;
        this.name = '';
        this.minRent = undefined;
        this.maxRent = undefined;
        this.spaceCount = 0;
    }
    return SpaceOption;
}());
exports.SpaceOption = SpaceOption;
